/**
 * Telangana district metadata aligned to map positions on
 * India_Telangana_numbered_district_map_2022.svg (Wikimedia Commons, CC BY-SA 4.0).
 * Serial 1–33 follows the conventional ordered list of all 33 districts; map label (cx, cy) matches the former number placement.
 */

export const TELANGANA_DISTRICTS = [
  { key: "adilabad", label: "Adilabad", lines: ["Adilabad"], cx: 236.4134, cy: 72.3352, hitR: 42 },
  { key: "bhadradri_kothagudem", label: "Bhadradri Kothagudem", lines: ["Bhadradri", "Kothagudem"], cx: 558.2391, cy: 366.2438, hitR: 44 },
  { key: "hanumakonda", label: "Hanumakonda", lines: ["Hanumakonda"], cx: 378.083, cy: 314.0141, hitR: 40 },
  { key: "hyderabad", label: "Hyderabad", lines: ["Hyderabad"], cx: 218.5193, cy: 410.9556, hitR: 36 },
  { key: "jagtial", label: "Jagtial", lines: ["Jagtial"], cx: 280.8983, cy: 185.9191, hitR: 38 },
  { key: "jangaon", label: "Jangaon", lines: ["Jangaon"], cx: 349.3649, cy: 355.5349, hitR: 36 },
  { key: "jayashankar_bhupalpally", label: "Jayashankar Bhupalpally", lines: ["Jayashankar", "Bhupalpally"], cx: 453.5519, cy: 236.6391, hitR: 44 },
  { key: "jogulamba_gadwal", label: "Jogulamba Gadwal", lines: ["Jogulamba", "Gadwal"], cx: 106.3024, cy: 622.0767, hitR: 40 },
  { key: "kamareddy", label: "Kamareddy", lines: ["Kamareddy"], cx: 153.9897, cy: 272.4937, hitR: 40 },
  { key: "karimnagar", label: "Karimnagar", lines: ["Karimnagar"], cx: 337.138, cy: 268.9941, hitR: 40 },
  { key: "khammam", label: "Khammam", lines: ["Khammam"], cx: 500.2237, cy: 441.5693, hitR: 40 },
  { key: "komaram_bheem_asifabad", label: "Komaram Bheem Asifabad", lines: ["Komaram Bheem", "Asifabad"], cx: 350.5885, cy: 101.7327, hitR: 44 },
  { key: "mahabubabad", label: "Mahabubabad", lines: ["Mahabubabad"], cx: 453.5519, cy: 375.676, hitR: 38 },
  { key: "mahbubnagar", label: "Mahbubnagar", lines: ["Mahbubnagar"], cx: 130.5874, cy: 508.3188, hitR: 42 },
  { key: "mancherial", label: "Mancherial", lines: ["Mancherial"], cx: 385.6154, cy: 162.5191, hitR: 38 },
  { key: "medak", label: "Medak", lines: ["Medak"], cx: 190.3444, cy: 330.7502, hitR: 38 },
  { key: "medchal_malkajgiri", label: "Medchal-Malkajgiri", lines: ["Medchal-", "Malkajgiri"], cx: 221.3775, cy: 382.817, hitR: 42 },
  { key: "mulugu", label: "Mulugu", lines: ["Mulugu"], cx: 490.2574, cy: 283.1202, hitR: 36 },
  { key: "nagarkurnool", label: "Nagarkurnool", lines: ["Nagarkurnool"], cx: 217.0592, cy: 573.554, hitR: 42 },
  { key: "nalgonda", label: "Nalgonda", lines: ["Nalgonda"], cx: 322.0491, cy: 484.9188, hitR: 40 },
  { key: "narayanpet", label: "Narayanpet", lines: ["Narayanpet"], cx: 74.8841, cy: 533.0955, hitR: 38 },
  { key: "nirmal", label: "Nirmal", lines: ["Nirmal"], cx: 206.6451, cy: 146.5177, hitR: 36 },
  { key: "nizamabad", label: "Nizamabad", lines: ["Nizamabad"], cx: 170.4087, cy: 206.9296, hitR: 40 },
  { key: "peddapalli", label: "Peddapalli", lines: ["Peddapalli"], cx: 359.9121, cy: 220.9658, hitR: 38 },
  { key: "rajanna_sircilla", label: "Rajanna Sircilla", lines: ["Rajanna", "Sircilla"], cx: 252.7345, cy: 248.0744, hitR: 40 },
  { key: "rangareddy", label: "Rangareddy", lines: ["Rangareddy"], cx: 199.9049, cy: 453.4451, hitR: 44 },
  { key: "sangareddy", label: "Sangareddy", lines: ["Sangareddy"], cx: 95.9394, cy: 359.417, hitR: 42 },
  { key: "siddipet", label: "Siddipet", lines: ["Siddipet"], cx: 275.3379, cy: 308.8431, hitR: 38 },
  { key: "suryapet", label: "Suryapet", lines: ["Suryapet"], cx: 410.7895, cy: 461.1227, hitR: 38 },
  { key: "vikarabad", label: "Vikarabad", lines: ["Vikarabad"], cx: 93.2685, cy: 432.8825, hitR: 36 },
  { key: "wanaparthy", label: "Wanaparthy", lines: ["Wanaparthy"], cx: 140.315, cy: 580.4847, hitR: 38 },
  { key: "warangal", label: "Warangal", lines: ["Warangal"], cx: 420.1388, cy: 325.9092, hitR: 38 },
  { key: "yadadri_bhuvanagiri", label: "Yadadri Bhuvanagiri", lines: ["Yadadri", "Bhuvanagiri"], cx: 292.7619, cy: 400.313, hitR: 44 },
] as const;

export type TelanganaDistrictKey = (typeof TELANGANA_DISTRICTS)[number]["key"];

export const TELANGANA_DISTRICT_KEYS = TELANGANA_DISTRICTS.map((d) => d.key) as TelanganaDistrictKey[];

export function isTelanganaDistrictKey(v: string): v is TelanganaDistrictKey {
  return (TELANGANA_DISTRICT_KEYS as string[]).includes(v);
}

/**
 * Map `district` values from DB/API (often title case or IGRS labels) to the canonical slug used on the map and in URLs.
 */
export function telanganaDistrictKeyFromStored(raw: string): TelanganaDistrictKey | null {
  const s = String(raw ?? "").trim();
  if (!s) return null;
  if (isTelanganaDistrictKey(s)) return s;
  const lower = s.toLowerCase();
  if (isTelanganaDistrictKey(lower)) return lower;
  const underscored = lower.replace(/[\s\-/]+/g, "_");
  if (isTelanganaDistrictKey(underscored)) return underscored;
  const normLabel = lower.replace(/\s+/g, " ").trim();
  const byLabel = TELANGANA_DISTRICTS.find((d) => d.label.toLowerCase() === normLabel);
  if (byLabel) return byLabel.key;
  const compact = normLabel.replace(/[^a-z0-9]/g, "");
  const byCompact = TELANGANA_DISTRICTS.find(
    (d) => d.label.toLowerCase().replace(/[^a-z0-9]/g, "") === compact,
  );
  return byCompact?.key ?? null;
}

export function telanganaDistrictLabel(key: TelanganaDistrictKey): string {
  return TELANGANA_DISTRICTS.find((d) => d.key === key)?.label ?? key;
}
